module.exports = __webpack_public_path__ + "static/media/web-view.40a5d87a.png";